import PropTypes from "prop-types"
import React from "react"

import { formatFontFamily } from "../WebsiteBuilderV2/utils/fontUtils"

import BlogTagFilter from "./BlogTagFilter"
import { formatTagLabel } from "./blogTagUtils"

const BlogIndexHeader = ({
  pageTitle,
  practiceName,
  postCount,
  filteredCount,
  activeTag,
  tags,
  onSelectTag,
  headingFont,
  headingWeight,
  paragraphFont,
  textDark,
  accentColor,
  headerBackground
}) => {
  const bodyFont = formatFontFamily(paragraphFont)
  const countLabel =
    filteredCount === postCount
      ? `${postCount} ${postCount === 1 ? "article" : "articles"}`
      : `${filteredCount} of ${postCount} ${postCount === 1 ? "article" : "articles"}`

  return (
    <header
      className="relative mb-2 w-full overflow-hidden border-b border-black/5"
      style={{ backgroundColor: headerBackground }}>
      <div
        className="pointer-events-none absolute -right-24 -top-24 size-72 rounded-full opacity-40 blur-3xl"
        style={{ backgroundColor: accentColor }}
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -bottom-24 -left-16 size-56 rounded-full opacity-25 blur-3xl"
        style={{ backgroundColor: accentColor }}
        aria-hidden
      />

      <div className="relative mx-auto w-full px-6 py-10 xl:px-20 lg:px-16 md:px-10 md:py-12">
        <div className="flex flex-col gap-8 lg:gap-10 min_md:flex-row min_md:items-start min_md:gap-8">
          <div className="min-w-0 min_md:w-1/2">
            {practiceName && (
              <p
                className="mb-3 text-xs font-bold uppercase tracking-[0.22em]"
                style={{ color: accentColor, fontFamily: bodyFont }}>
                {practiceName}
              </p>
            )}

            <h1
              className="text-4xl font-bold leading-[1.08] tracking-tight lg:text-[3.25rem] md:text-5xl"
              style={{
                color: textDark,
                fontFamily: headingFont,
                fontWeight: headingWeight || "700"
              }}>
              {pageTitle}
            </h1>

            <p
              className="mt-4 text-base leading-relaxed md:text-lg"
              style={{ color: textDark, opacity: 0.72, fontFamily: bodyFont }}>
              {activeTag ? (
                <>
                  {countLabel} about <span className="font-semibold">{formatTagLabel(activeTag)}</span>
                </>
              ) : (
                <>{countLabel} — explore ideas and stories below</>
              )}
            </p>
          </div>

          {tags.length > 0 && (
            <div className="min-w-0 min_md:w-1/2">
              <div className="h-full rounded-2xl border border-white/60 bg-white/90 p-4 shadow-sm backdrop-blur-sm min_md:p-5">
                <BlogTagFilter
                  tags={tags}
                  activeTag={activeTag}
                  onSelectTag={onSelectTag}
                  accentColor={accentColor}
                  textDark={textDark}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  )
}

BlogIndexHeader.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  practiceName: PropTypes.string,
  postCount: PropTypes.number.isRequired,
  filteredCount: PropTypes.number.isRequired,
  activeTag: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelectTag: PropTypes.func.isRequired,
  headingFont: PropTypes.string,
  headingWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  paragraphFont: PropTypes.string,
  textDark: PropTypes.string.isRequired,
  accentColor: PropTypes.string.isRequired,
  headerBackground: PropTypes.string.isRequired
}

export default BlogIndexHeader
